class PriceRage extends HTMLElement {
  constructor() {
    super();
    this.sortingDropdown = null;
    this.minRange = null;
    this.maxRange = null;
    this.minValueInput = null;
    this.maxValueInput = null;
    this.track = null;
  }

  validateInput(input) {
    input.value = input.value.replace(/[^0-9.]/g, '');
    const value = input.value;

    if (value.startsWith('0') && value.length > 1 && !value.startsWith('0.')) {
      input.value = value.substring(1);
    }

    if ((value.match(/\./g) || []).length > 1 || value.indexOf('.') === 0) {
      input.value = value.slice(0, -1);
    }

    if (value.includes('.')) {
      const parts = value.split('.');
      if (parts[1].length > 2) {
        input.value = parts[0] + '.' + parts[1].substring(0, 2);
      }
    }

    const numericValue = parseFloat(input.value);
    const min = parseFloat(input.getAttribute('min'));
    const max = parseFloat(input.getAttribute('max'));

    if (isNaN(numericValue) || numericValue < min) {
      input.value = min;
    } else if (numericValue > max) {
      input.value = max;
    }
  }

  updateTrack() {
    const min = parseFloat(this.minRange.value);
    const max = parseFloat(this.maxRange.value);
    const rangeMax = parseFloat(this.minRange.max);
    const minPercent = (min / rangeMax) * 100;
    const maxPercent = (max / rangeMax) * 100;
    this.track.style.left = minPercent + '%';
    this.track.style.width = maxPercent - minPercent + '%';
  }

  updateInputs() {
    this.minValueInput.value = parseFloat(this.minRange.value);
    this.maxValueInput.value = parseFloat(this.maxRange.value);
    const changeEvent = new Event('input');
    this.updateTrack();
    this.minValueInput.dispatchEvent(changeEvent);
    this.maxValueInput.dispatchEvent(changeEvent);
  }

  initListeners() {
    if (this.minRange) {
      this.minRange.addEventListener('input', () => {
        if (parseInt(this.minRange.value) > parseInt(this.maxRange.value)) {
          this.minRange.value = this.maxRange.value;
        }
        this.updateInputs();
      });

      this.minRange.addEventListener('change', () => {
        this.minValueInput.value = parseFloat(this.minRange.value);
        this.minValueInput.dispatchEvent(new Event('change'));
      });
    }

    if (this.maxRange) {
      this.maxRange.addEventListener('input', () => {
        if (parseInt(this.maxRange.value) < parseInt(this.minRange.value)) {
          this.maxRange.value = this.minRange.value;
        }
        this.updateInputs();
      });

      this.maxRange.addEventListener('change', () => {
        this.maxValueInput.value = parseFloat(this.maxRange.value);
        this.maxValueInput.dispatchEvent(new Event('change'));
      });
    }

    if (this.minValueInput) {
      this.minValueInput.addEventListener('input', () => {
        this.validateInput(this.minValueInput);
        this.minRange.value = this.minValueInput.value;
        if (parseInt(this.minValueInput.value) > parseInt(this.maxValueInput.value)) {
          this.maxValueInput.value = this.minValueInput.value;
          this.maxRange.value = this.minValueInput.value;
        }
        this.updateTrack();
      });
    }

    if (this.maxValueInput) {
      this.maxValueInput.addEventListener('input', () => {
        this.validateInput(this.maxValueInput);
        this.maxRange.value = this.maxValueInput.value;
        if (parseInt(this.maxValueInput.value) < parseInt(this.minValueInput.value)) {
          this.minValueInput.value = this.maxValueInput.value;
          this.minRange.value = this.maxValueInput.value;
        }
        this.updateTrack();
      });
    }
    this.updateTrack();
  }

  init() {
    this.minRange = this.querySelector('#minRange');
    this.maxRange = this.querySelector('#maxRange');
    this.minValueInput = this.querySelector('[data-filter-price-from]');
    this.maxValueInput = this.querySelector('[data-filter-price-to]');
    this.track = this.querySelector('#price-range-track');
    this.initListeners();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }
}

customElements.define('price-range', PriceRage);

class MainCollection extends HTMLElement {
  constructor() {
    super();

    this.fastDeliverySizes = new Set();
    this.pageCache = new Map();
    this.abortController = null;

    this.data_id = [
      '[data-product-list-collection]',
      '[data-update-sorting]',
      '[data-load-more-update]',
      '[data-update-active-filter]',
      '[data-update-products-count]',
      '[data-filters-update-clear-all]',
      '[data-update-load-more-count]',
      '[data-update-pagination]',
    ];

    this.applyFiltersDebounced = this.debounce(this.applyFilters.bind(this), 250);

    this.addEventListener('click', (e) => {
      const loadMoreBtn = e.target.closest('[data-next-page-url]');
      const removeActiveFilter = e.target.closest('.rd-ff-drawer__clear-js');

      if (removeActiveFilter) {
        e.preventDefault();
        const url = removeActiveFilter.dataset.removeFilter;
        if (url) this.getChangesCollection(url);
      }

      if (loadMoreBtn) {
        e.preventDefault();
        const url = loadMoreBtn.dataset.nextPageUrl;
        if (url) this.changePage(url);
      }
    });

    this.addEventListener('change', (e) => {
      const form = e.target.closest('[data-update-sorting], [data-form-filters]');
      if (!form) return;

      e.preventDefault();
      this.applyFiltersDebounced(form);
    });
  }

  connectedCallback() {
    this.updateSizeFastDelivery();
  }

  /* =========================
     FILTERS
  ========================= */

  applyFilters(form) {
    const url = new URL(window.location);
    const formData = new FormData(form);

    form.querySelectorAll('input[name], select[name]').forEach((el) => {
      url.searchParams.delete(el.name);
    });

    const selectedSizes = [];

    formData.forEach((value, key) => {
      url.searchParams.append(key, value);
      if (key === 'filter.v.option.størrelse') selectedSizes.push(value);
    });

    const hasFast = selectedSizes.some((s) => this.fastDeliverySizes.has(s));

    if (hasFast) {
      url.searchParams.set('filter.v.m.custom.fast_delivery', '1');
    } else {
      url.searchParams.delete('filter.v.m.custom.fast_delivery');
    }

    this.getChangesCollection(url.toString(), true);
  }

  /* =========================
     CORE FETCH
  ========================= */

  async getChangesCollection(url, update = true) {
    if (update) {
      this.scrollToCollection();
      this.classList.add('is-loading');
    }

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    try {
      let html;

      if (this.pageCache.has(url)) {
        html = this.pageCache.get(url);
      } else {
        const res = await fetch(url, { signal: this.abortController.signal });
        html = await res.text();
        this.pageCache.set(url, html);
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (update) {
        this.updateFilters(doc);
        this.updateMainBlocks(doc);
      } else {
        this.appendProducts(doc);
      }

      this.updateURL(url);
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.error('Collection error:', e);
      }
    } finally {
      this.classList.remove('is-loading');
    }
  }

  /* =========================
     UPDATE HELPERS
  ========================= */

  updateFilters(doc) {
    const currentForms = document.querySelectorAll('[data-update-form-filters]');
    const newForms = doc.querySelectorAll('[data-update-form-filters]');

    currentForms.forEach((el, i) => {
      if (newForms[i]) el.innerHTML = newForms[i].innerHTML;
    });

    const currentSizes = document.querySelectorAll('[data-update-filters-size]');
    currentSizes.forEach((el) => {
      const key = el.dataset.updateFiltersSize;
      const newEl = doc.querySelector(`[data-update-filters-size="${CSS.escape(key)}"]`);
      if (!newEl) return;

      el.checked = newEl.checked;
      el.disabled = newEl.disabled;
    });
  }

  updateMainBlocks(doc) {
    this.data_id.forEach((selector) => {
      const oldEl = document.querySelector(selector);
      const newEl = doc.querySelector(selector);

      if (oldEl && newEl) {
        oldEl.innerHTML = newEl.innerHTML;
      } else if (selector === '[data-product-list-collection]') {
        const currentEmpty = document.querySelector('[data-empty-collection]');
        const newEmpty = doc.querySelector('[data-empty-collection]');
        currentEmpty.innerHTML = newEmpty.innerHTML;
      }
    });
  }

  appendProducts(doc) {
    const currentList = document.querySelector('[data-product-list-collection]');
    const newList = doc.querySelector('[data-product-list-collection]');
    const loadMore = document.querySelector('[data-load-more-update]');
    const newLoadMore = doc.querySelector('[data-load-more-update]');
    const counter = document.querySelector('[data-update-load-more-count]');

    if (currentList && newList) {
      newList.childNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          currentList.appendChild(node.cloneNode(true));
        }
      });
    }

    if (loadMore) {
      if (newLoadMore) loadMore.innerHTML = newLoadMore.innerHTML;
      else loadMore.style.display = 'none';
    }

    if (counter && currentList) {
      const total = Number(counter.dataset.totalProducts);
      counter.textContent = `Viewed ${currentList.children.length} of ${total} products`;
    }
  }

  /* =========================
     SIZE FAST DELIVERY
  ========================= */

  async updateSizeFastDelivery() {
    const labels = this.querySelectorAll('[data-filters-size-label]');
    if (!labels.length) return;

    this.fastDeliverySizes.clear();

    try {
      const url = `${this.collectionUrl}?filter.v.m.custom.fast_delivery=1`;
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      doc.querySelectorAll('[data-filters-size-label]').forEach((el) => {
        const size = el.dataset.filtersSizeLabel;
        if (size) this.fastDeliverySizes.add(size);
      });

      labels.forEach((label) => {
        const size = label.dataset.filtersSizeLabel;
        const fast = label.querySelector('.fast-dellivery-js');
        const text = label.querySelector('.rd-ff-drawer__label-span');

        if (this.fastDeliverySizes.has(size)) {
          fast.style.display = 'block';
          text.style.color = '#182cd4';
        } else {
          fast.style.display = 'none';
          text.style.color = '#000';
        }
      });
    } catch (e) {
      console.error('Fast delivery error:', e);
    }
  }

  /* =========================
     UTILS
  ========================= */

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  scrollToCollection() {
    const el = document.getElementById('rd-main-collection');
    const header = document.querySelector('header');
    if (!el) return;

    const offset = header ? header.offsetHeight : 0;
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset - 10;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  updateURL(url) {
    const u = new URL(url, location.origin);
    u.searchParams.delete('page');
    history.replaceState(null, '', u.pathname + u.search);
  }

  changePage(url) {
    const page = new URL(url, location.origin).searchParams.get('page');
    const u = new URL(location);
    u.searchParams.set('page', page);
    this.getChangesCollection(u.toString(), false);
  }

  get collectionUrl() {
    return this.dataset.collectionUrl || location.pathname;
  }
}

customElements.define('main-collection', MainCollection);
